<template>
    <svg xmlns="http://www.w3.org/2000/svg" :class="'i-caret--' + direction" viewBox="0 0 100 100"><title>caret</title>
        <polygon points="49.43 85.02 2.06 37.64 12.08 27.62 49.43 64.98 87.42 26.99 97.44 37.01 49.43 85.02"/>
    </svg>
</template>

<script>

  export default {
    name: "i-caret",
    props: {
      direction: { type: String, default: "down" }
    }
  }
</script>
<style lang="scss">
    .i-caret {
        transition: .2s ease all;
        transform: rotate(0deg);

        &--left {
            transform: rotate(90deg)
        }

        &--up {
            transform: rotate(180deg)
        }

        &--right {
            transform: rotate(270deg)
        }

    }
</style>
